<!--
 * @Author: cmchiu
 * @Date: 2022-06-27 15:49:53
 * @LastEditTime: 2023-09-23 16:19:06
 * @LastEditors: cmchiu
 * @Description: 
 * @FilePath: \campus2022\campus2022-ClientApp\src\components\InfoList\infolist.vue
 * 
-->
<template>
    <div class="info-ls">
        <div v-for="item in list" :key="item.key" class="list-group list-group-flush list_atag">
            <div class="list-group-item list_title">
                <span v-if="item.relatedLink === null" :id="item.title">{{ item.title }}</span>
                <el-link
                    v-else
                    :href="item.relatedLink"
                    target="_blank"
                    rel="noreferrer noopener"
                    :title="`${item.title}（另開視窗）`"
                    tabindex="0"
                >
                    <span :id="item.title">{{ item.title }}</span>
                </el-link>
            </div>

            <template v-if="item.info !== ''">
                <div class="list-group-item list-group-item-action">
                    <a v-html="item.info"></a>
                </div>
            </template>
            <template v-esle v-for="obj in item.detail">
                <div v-if="obj.Content != undefined" :key="obj.index" class="list-group-item list-group-item-action">
                    <a v-if="obj.URL == ''" v-html="`<b>${obj.Title}</b>`"></a>
                    <a
                        v-else
                        :href="obj.URL"
                        :target="obj.ShowType"
                        :rel="obj.ShowType === '_blank' ? 'noreferrer noopener' : ''"
                        v-html="`<b>${obj.Title}</b>`"
                        :title="`${obj.Title}${obj.ShowType === '_blank' ? '（另開視窗）' : ''}`"
                        tabindex="0"
                    ></a>
                    <br />
                    <a v-html="obj.Content"></a>
                </div>
                <template v-else>
                    <a
                        :key="obj.index"
                        :href="obj.URL"
                        :target="obj.ShowType"
                        :rel="obj.ShowType === '_blank' ? 'noreferrer noopener' : ''"
                        class="list-group-item list-group-item-action"
                        v-html="`» ${obj.Title}`"
                        :title="`${obj.Title}${obj.ShowType === '_blank' ? '（另開視窗）' : ''}`"
                        tabindex="0"
                    ></a>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'infoLs',

    props: {
        datas: {
            type: [String, Array, Object],
            default: null,
        },
    },

    data: function () {
        return {
            list: this.datas,
        }
    },
}
</script>

<style scoped lang="scss">
::v-deep .list-group-item.list_title {
    a:focus {
        border: 0.1em #fff solid;
        box-shadow: 0 0 0 0.1em #000 inset;
        border-radius: 0.25em;
        padding: 0.1em 0.2em;
    }
}
</style>
